import { render } from "./EmployeeJob.vue?vue&type=template&id=1dfb2fdc&scoped=true"
import script from "./EmployeeJob.vue?vue&type=script&lang=js"
export * from "./EmployeeJob.vue?vue&type=script&lang=js"

import "./employee.scss?vue&type=style&index=0&id=1dfb2fdc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dfb2fdc"]])

export default __exports__